import {TestPassState, TestResponse, TestResponseCommands} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/models';
import {Step} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/step';
import {Role} from '@app/modules/shared/data/constants';
import {
  MicrophoneCheckManager
} from "@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/microphone-check-manager";

export abstract class CheckItemsManager {
  name: string;
  icon;
  steps: Step[] = [];
  currentStepIndex = 0;
  testsPassState = TestPassState.PENDING;
  isAtLeastOneTestFail = false;
  needToShowSummaryButton = false;
  userRole: Role;
  isDisabled = true;
  isBlocked = false;
  isSkipped = false;
  isHidden = false;

  constructor(userRole: Role) {
    this.userRole = userRole;
  }


  runTests(resultCallback: (param: TestResponse) => void) {
    this.isDisabled = false;
    if (!this.steps[this.currentStepIndex].isHidden) {
      this.testPreProcessing();
      this.steps[this.currentStepIndex].runStep().subscribe((testResult: TestResponse) => {
        this.testPostProcessing();
        this.updateIsTestPassed();
        switch (testResult.command) {
          case TestResponseCommands.NEXT: {
            if (this.doesAllStepsProcessed()) {
              resultCallback(testResult);
            } else {
              this.currentStepIndex++;
              this.runTests(resultCallback);
            }
            break;
          }
          case TestResponseCommands.REQUEST_QUESTION: {
            resultCallback(testResult);
            break;
          }
          case TestResponseCommands.REQUEST_VIDEO: {
            resultCallback(testResult);
            break;
          }
          case TestResponseCommands.REQUEST_MIC: {
            resultCallback(testResult);
            break;
          }
          case TestResponseCommands.GUEST: {
            resultCallback(testResult);
            break;
          }
          case TestResponseCommands.VIDEO_MIC_IS_BLOCK: {
            resultCallback(testResult);
            break;
          }
          case TestResponseCommands.SHOW_ERROR: {
            resultCallback(testResult);
            break;
          }
        }
      });
    } else {
      if (this.doesAllStepsProcessed()) {
        resultCallback(new TestResponse(TestResponseCommands.NEXT));
      } else {
        // run next step
        this.currentStepIndex++;
        this.runTests(resultCallback);
      }
    }
  }

  testPostProcessing() {
  }

  testPreProcessing() {
  }

  updateIsTestPassed() {
    let isAllTestPassed = true;
    let isPending = false;

    for (const item of this.steps) {
      if (!item.isHidden) {
        if (item.testResult.status === TestPassState.FAILED) {
          isAllTestPassed = false;
        }
        if (item.testResult.status === TestPassState.PENDING) {
          isPending = true;
        }
      }
    }
    this.isAtLeastOneTestFail = !isAllTestPassed;
    if (isPending) {
      this.testsPassState = TestPassState.PENDING;
    } else if (this.isAtLeastOneTestFail) {
      this.testsPassState = TestPassState.FAILED;
    } else {
      this.testsPassState = TestPassState.PASSED;
    }
  }

  setCurrentStepPayload(payload) {
    this.steps[this.currentStepIndex].stepPayload = payload;
  }

  resetManager() {
    this.setSkipped(false);
    for (const item of this.steps) {
      item.resetStep();
    }
    this.currentStepIndex = 0;
    this.testsPassState = TestPassState.PENDING;
    this.isAtLeastOneTestFail = false;
  }

  doSkip() {
    this.currentStepIndex++;
  }

  setSkipped(isSkipped) {
    this.isSkipped = isSkipped;
  }

  setBlocked(isBlocked) {
    this.isBlocked = isBlocked;
  }

  /**
   * method check is there any remaining step to process
   */
  doesAllStepsProcessed() {
    for (let i = this.currentStepIndex + 1; i < this.steps.length; i++) {
      if (!this.steps[i].isHidden) {
        return false;
      }
    }
    return true;
  }

  generateMessage() {
    let message = '';
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < this.steps.length; i++) {
      message += this.steps[i].toString();
    }
    return message;
  }
}
